import React from 'react';

//import './index.css';
import styles from './Test.module.css';


const Test = () => {
	return (
		<div className={styles.test}>
			beginning of text, no padding	
		</div>
	);
}

export default Test;